import { render, staticRenderFns } from "./PersonalQuestionsAnswers.vue?vue&type=template&id=c3dc31e8&"
import script from "./PersonalQuestionsAnswers.vue?vue&type=script&lang=js&"
export * from "./PersonalQuestionsAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports